<template>
  <div>
    <p class="text-2xl mb-6">Propinas por formas de pago</p>
    <ReporteArqueoCajaPropina :filtrosShow="true" :exportar="['EXCEL','PDF']"></ReporteArqueoCajaPropina>
  </div>


</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiLabelVariantOutline, mdiCurrencyUsd, mdiHelpCircleOutline } from '@mdi/js'

// demos    
import ReporteArqueoCajaPropina from '../general/componentes/ReporteArqueoCajaPropina.vue'
export default {
  components: {
    ReporteArqueoCajaPropina
  },
  setup() {


    return {}
  },
}
</script>
